import { render, staticRenderFns } from "./Export.vue?vue&type=template&id=20a751c2&scoped=true"
import script from "./Export.vue?vue&type=script&lang=js"
export * from "./Export.vue?vue&type=script&lang=js"
import style0 from "./Export.vue?vue&type=style&index=0&id=20a751c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a751c2",
  null
  
)

export default component.exports